import { UrlImagenes } from 'src/parametros';
import sinImagen from 'src/assets/img/sinImagen.jpg';

export const imagenSeguro = (microseguro) => {
  if (microseguro?.logo) {
    return UrlImagenes + microseguro?.logo;
  }
  return sinImagen;
};
